module.exports = __webpack_public_path__ + "static/img/logo86.db78d3f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo86.png
// module id = ZAgr
// module chunks = 1